<script>
    import axios from 'axios'
    import {nextTick} from "vue";
    import RadioButton from "primevue/radiobutton";
    import Divider from "primevue/divider";
    import Textarea from "primevue/textarea";
    import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";

    export default {
        data() {
            return {
                loading: false,
                list: null,
                error: null,
                limit: 300,
                model: {targetNode: -2}
            }
        },
        props: ["name", "uid", "type"],
        methods: {
            save(){
                let self = this;
                if(this.getData.length === 0){
                    this.error = this.$t('lang.cluster.enter_one_err');
                    return false;
                }
                if(this.getData.length > this.limit){
                    this.error = this.$t('lang.cluster.limit_count_err', [this.limit]);
                    return false;
                }

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: Object.assign({}, this.model, {templates: self.getData})
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.list = null;
                this.error = null
            },
            onOpen() {
                let self = this;
                nextTick(() => {
                    self.$refs["modalInput"].$el.focus()
                });
                this.model = {
                    targetNode: -2,
                };
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/clustering/' + this.uid + '/delete/template';
            },
            getData(){
                if(this.list){
                    return this.list.replace(/\r\n/g,"\n").split("\n").filter(item => {return item != ""});
                }
                return [];
            },
            btnModalLabel(){
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            count(){
                return this.getData.length;
            }
        },
        components: {
            TemplatesLabelCounts,
            AdaptersDialog,
            RadioButton,
            Divider,
            Textarea,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.cluster.words_list')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <div class="field">
                <TemplatesLabelCounts :text="$t('lang.cluster.tmpl_list_rules')" :count="count" :limit="limit" />
                <Textarea v-model="list" rows="6" ref="modalInput" />
            </div>
            <p class="flex flex-column row-gap-2">
                {{ $t('lang.cluster.tmpl_help_label') }}
                <label><code>%</code>: {{ $t('lang.cluster.tmpl_help_label_1') }}</label>
                <label><code>_</code>: {{ $t('lang.cluster.tmpl_help_label_2') }}</label>
            </p>
            <Divider />
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div class="field-radiobutton">
                    <RadioButton v-model="model.targetNode" inputId="f_deleted" name="targetNode" :value="-2" />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton v-model="model.targetNode" inputId="f_unallocated" name="targetNode" :value="-1" />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
